<div class="page">
  <app-page-header page-title="accessLogs.list.pageTitle"></app-page-header>
  <div class="page-content">

    <mat-card class="custom-card">
      <mat-card-title>{{ 'accessLogs.list.listTab.title' | translate }}</mat-card-title>
      <mat-card-subtitle>{{ 'common.words.listTabSubtitle' | translate }}</mat-card-subtitle>
      <mat-card-content>
        <mat-expansion-panel expanded="true" class="card-expansion-panel mat-elevation-z0">
          <mat-expansion-panel-header class="card-expansion-trigger"
            matTooltip="{{ 'common.words.toggleCard' | translate }}"></mat-expansion-panel-header>
          <div class="table-wrapper">
            <div class="table-toolbar">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-6">
                  <!-- <mat-form-field>
                    <input matInput placeholder="{{ 'common.words.search' | translate }}" #input>
                    <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                      class="reset-input-icon" *ngIf="input.value"></mat-icon>
                  </mat-form-field> -->
                </div> <!-- /.col-12.col-md-4 -->
                <div class="col-12 col-sm-6 col-md-6 text-right">
                  <button mat-button (click)="onExport()" class="d-none d-sm-inline-block"
                    *ngIf="loggedUserPermissions.includes('canExportAccessLogs')">
                    <mat-icon fontSet="fal" fontIcon="fa-download"></mat-icon>
                    {{ 'common.words.export' | translate }}
                  </button>
                  <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                    <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                    {{ 'common.cta.resetFilters' | translate }}
                  </button>
                </div> <!-- /.col-12.col-md-8 -->
              </div> <!-- /.row -->
            </div> <!-- /.table-toolbar -->
            <div class="spinner-container" *ngIf="dataSource.loading$ | async">
              <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
            </div> <!-- /.spinner-container -->
            <div class="table-responsive">
              <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="createdAt"
                matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                <ng-container matColumnDef="index">
                  <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    {{ i + 1 }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef></td>
                </ng-container>
                <ng-container matColumnDef="user">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'accessLogs.fields.user' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.firstName }} {{ element.lastName }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="userFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(userFilter)"
                        class="reset-input-icon" *ngIf="userFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'accessLogs.fields.email' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.email }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="emailFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(emailFilter)"
                        class="reset-input-icon" *ngIf="emailFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="company">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-20">
                    {{ 'accessLogs.fields.company' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.companyName ? element.companyName : '' }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="companyFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(companyFilter)"
                        class="reset-input-icon" *ngIf="companyFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                    {{ 'accessLogs.fields.type' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.type.toUpperCase() }}
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="typeFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(typeFilter)"
                        class="reset-input-icon" *ngIf="typeFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="role">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'accessLogs.fields.role' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <mat-chip-list class="d-block py-2 px-1">
                      <mat-chip
                        *ngIf="element.chosenRole && element.chosenRole.roleType && element.chosenRole.roleType === 'admin'"
                        color="primary" selected class="mat-chip-sm">
                        {{ 'roles.types.' + element.chosenRole.roleType | translate }}
                      </mat-chip>
                      <mat-chip
                        *ngIf="element.chosenRole && element.chosenRole.roleType && element.chosenRole.roleType === 'master'"
                        color="primary" selected class="mat-chip-sm">
                        {{ 'roles.types.' + element.chosenRole.roleType | translate }}
                      </mat-chip>
                      <mat-chip
                        *ngIf="element.chosenRole && element.chosenRole.roleType && element.chosenRole.roleType === 'operator'"
                        color="accent" selected class="mat-chip-sm">
                        {{ 'roles.types.' + element.chosenRole.roleType | translate }}
                      </mat-chip>
                      <mat-chip
                        *ngIf="element.chosenRole && element.chosenRole.roleType && element.chosenRole.roleType === 'collaborator'"
                        color="secondary" selected class="mat-chip-sm">
                        {{ 'roles.types.' + element.chosenRole.roleType | translate }}
                      </mat-chip>
                      <mat-chip
                        *ngIf="element.chosenRole && element.chosenRole.roleType && element.chosenRole.roleType === 'temporary'"
                        color="secondary" selected class="mat-chip-sm">
                        {{ 'roles.types.' + element.chosenRole.roleType | translate }}
                      </mat-chip>
                      <mat-chip
                        *ngIf="element.chosenRole && element.chosenRole.roleType && element.chosenRole.roleType === 'shared'"
                        color="secondary" selected class="mat-chip-sm">
                        {{ 'roles.types.' + element.chosenRole.roleType | translate }}
                      </mat-chip>
                      <mat-chip
                        *ngIf="element.chosenRole && element.chosenRole.roleType && element.chosenRole.roleType === 'external'"
                        color="secondary" selected class="mat-chip-sm">
                        {{ 'roles.types.' + element.chosenRole.roleType | translate }}
                      </mat-chip>
                      <mat-chip *ngIf="!element.chosenRole || (element.chosenRole && !element.chosenRole.roleType)"
                        color="secondary" selected class="mat-chip-sm">
                        no role
                      </mat-chip>
                    </mat-chip-list>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <mat-select [formControl]="roleFilter">
                        <mat-option>{{ 'common.words.all' | translate }}</mat-option>
                        <mat-option *ngFor="let role of filterRoleTypes" [value]="role.value">
                          {{ role.label }}</mat-option>
                      </mat-select>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(roleFilter)"
                        class="reset-input-icon" *ngIf="roleFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="ipAddress">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'accessLogs.fields.ipAddress' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.ipAddress }} <span
                      *ngIf="element.ipAddress === '::1'">({{ 'common.words.you' | translate }})</span>
                  </td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                      <input matInput [formControl]="ipAddressFilter">
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(ipAddressFilter)"
                        class="reset-input-icon" *ngIf="ipAddressFilter.value"></mat-icon>
                    </mat-form-field>
                  </td>
                </ng-container>
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'accessLogs.fields.createdAt' | translate }}
                  </th>
                  <td mat-cell *matCellDef="let element">{{ element.createdAt | dateTimeFormat }}</td>
                  <td mat-footer-cell *matFooterCellDef>
                    <mat-form-field class="filter">
                      <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                      <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                        placeholder="{{ 'common.cta.select' | translate }}" [formControl]="createdAtFilter"
                        style="cursor: pointer" />
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(createdAtFilter)"
                        class="reset-input-icon" *ngIf="createdAtFilter.value"></mat-icon>
                      <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                      <mat-datepicker #dp></mat-datepicker>
                    </mat-form-field>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                  [class.even-row]="(i % 2) == 0"></tr>
                <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
              </table>
              <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                showFirstLastButtons></mat-paginator>
            </div> <!-- /.table-responsive -->
          </div> <!-- /.table-wrapper -->
        </mat-expansion-panel>
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->